import {
  type TtsSettings,
  useTtsSettingsStore,
} from "@/stores/tts-settings-store";

/**
 * Whether read-aloud can speak at all: switched on, usable, and a voice
 * chosen. The one gate for every "will this be spoken?" decision.
 */
export function canSpeak(
  settings: TtsSettings = useTtsSettingsStore.getState(),
): settings is TtsSettings & {
  denkerVoiceId: NonNullable<TtsSettings["denkerVoiceId"]>;
} {
  return (
    settings.enabled && settings.premiumAvailable && !!settings.denkerVoiceId
  );
}
